//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
import { Breadcrumbs } from '~/plugins/breadcrumbs'
import { asyncDataCatch, asyncDataStart } from '~/utils/asyncData'
import SectionText from '~/components/section/section-text'
import JobsSlider from '~/components/section/selection/jobs_slider'

export default {
  name: 'WorkWithTubberJob',
  components: {
    JobsSlider,
    SectionText
  },
  async asyncData (ctx) {
    await asyncDataStart(ctx)

    try {
      let page = null
      const lang = ctx.store.getters['lang/locale']
      const { data } = await ctx.$axios.get('/api/content-page?link=careers&lang=' + lang + '&job=' + ctx.route.params.jobId)
      page = data

      const crubms = Breadcrumbs.get(ctx.app.i18n, 'page', ctx.route, [{
        title: ctx.app.i18n.t('careers-new'),
        url: ctx.app.router.resolve({ name: 'work-with-tubber' }).href
      }, {
        title: page.job.Posting_Title,
        url: ctx.route.fullPath
      }])
      await ctx.store.dispatch('setBreadcrumbs', crubms)

      if (Object.keys(page).length === 0 || Object.keys(page.job).length === 0) {
        ctx.redirect(301, ctx.app.router.resolve({ name: 'work-with-tubber' }).href)
        return
      }
      ctx.store.commit('SET_META_DATA', {
        title: page.job.Posting_Title + ' - ' + page.data.meta_title,
        meta: [
          { name: 'title', property: 'og:title', hid: 'title', content: page.job.Posting_Title + ' - ' + page.data.meta_title },
          { name: 'description', property: 'og:description', hid: 'description', content: page.data.meta_descrtiption },
          { name: 'twitter:title', content: page.job.Posting_Title + ' - ' + page.data.meta_title },
          { name: 'author', content: 'Tubber' },
          { name: 'twitter:description', content: page.data.meta_descrtiption }
        ],
        link: []
      })
      return {
        lang,
        page
      }
    } catch (e) {
      return asyncDataCatch(ctx, e)
    }
  },
  data () {
    return {
      filter: 'all',
      limit: 3
    }
  },
  head () {
    return {
      title: this.page.job.Posting_Title + ' - ' + this.page.data.meta_title,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.page.data.meta_descrtiption
        },
        {
          hid: 'keywords',
          name: 'keywords',
          content: this.page.data.meta_keywords
        }
      ]
    }
  },
  computed: {
    ...mapState({
      windowBreakpoint: 'breakpoint'
    }),
    filteredJobs () {
      const sect = this.page.sections.find(s => s.type === 'jobs-list')
      return sect.jobsList.jobs.filter((j) => {
        return (j.type === this.page.job.Job_Type && j.id !== this.page.job.id)
      }).slice(0, this.limit)
    },
    imageSections () {
      if (this.page && this.page.sections) {
        return this.page.sections.filter(i => i.type === 'image-text-right' || i.type === 'image-text-left')
      }
      return []
    },
    textSections () {
      if (this.page && this.page.sections) {
        return this.page.sections.filter(i => i.type === 'section-text')
      }
      return []
    },
    jsonFields () {
      if (this.page && this.page.sections) {
        return this.page.sections.filter(i => i.type === 'json-data')
      }
      return []
    },
    getSliderSettings: app => (name) => {
      const isSlider = app.$store.state.breakpoint.screen.widthMinCalc <= 1024
      const SETTINGS = {
        'discover-flotilla': {
          isSlider: true,
          settings: {
            arrows: false,
            slidesToShow: 1,
            responsive: [
              {
                breakpoint: 576,
                settings: {
                  slidesToShow: 2,
                  arrows: false
                }
              },
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 3,
                  dots: false,
                  arrows: true
                }
              }
            ]
          }
        }
      }
      return {
        body: {
          isSlider,
          settings: {
            type: 'slider',
            gaps: {
              value: 1
            }
          },
          ...SETTINGS[name]
        }
      }
    },
    getCountyCode () {
      const countries = {
        Netherlands: 'NL',
        Croatia: 'CR',
        Greece: 'GR'
      }

      return countries[this.page.job.Country] || 'NL'
    }
  },
  jsonld () {
    if (!this.page.job.Salary) {
      return null
    }
    return {
      name: 'Tubber',
      '@context': 'http://schema.org',
      '@type': 'JobPosting',
      title: this.page.job.Posting_Title,
      description: this.page.job.Job_Description,
      identifier: {
        '@type': 'PropertyValue',
        name: 'Tubber',
        value: this.page.job.Job_Opening_ID
      },
      datePosted: this.page.job.Date_Opened,
      validThrough: `${this.page.job.Target_Date}T00:00`,
      employmentType: this.page.job.City ? 'CONTRACTOR' : 'OTHER',
      hiringOrganization: {
        '@type': 'Organization',
        name: 'Tubber',
        sameAs: 'https://www.tubber.com/en/'
      },
      ...(this.page.job.City
        ? {
            jobLocation: {
              '@type': 'Place',
              address: {
                '@type': 'PostalAddress',
                streetAddress: this.page.job.Street,
                addressLocality: this.page.job.City,
                addressRegion: this.page.job.State,
                postalCode: this.page.job.Zip_Code,
                addressCountry: this.getCountyCode
              }
            }
          }
        : {}),
      baseSalary: {
        '@type': 'MonetaryAmount',
        currency: 'EUR',
        value: {
          '@type': 'QuantitativeValue',
          value: this.page.job.Salary,
          unitText: 'MONTH'
        }
      }
    }
  }
}
